// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span.select2.select2-container {\n  width: 100% !important;\n}", "",{"version":3,"sources":["webpack://./resources/js/components/shared/FilterBox.vue"],"names":[],"mappings":"AACA;EACI,sBAAA;AAAJ","sourcesContent":["\nspan.select2.select2-container {\n    width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
